import React, {useEffect, useState} from "react";
import {BidBaseModel, BidStatus, blank_bid} from "./bidding_model";
import {useNavigate, useParams} from "react-router-dom";
import {ColumnDef} from "@tanstack/react-table";
import {Card, CardContent, CardHeader, CardTitle,} from "../ui/card";
import {moneyFormatter} from "../../lib/formatters";
import {useAuthInfo} from "@propelauth/react";
import {deleteWithToken, fetchWithToken, postWithToken} from "../../api/apiBase";
import {SortableHeader} from "../ui/tableUtils";
import {TrashIcon} from "lucide-react";
import {CompanyType} from "../../models/company";
import TableFilters, { Filter } from "../ui/TableFilter";
import BiddingBuilderSummaryView from "./BiddingBuilderSummaryView";
import DeveloperBidSummaryView from "./BiddingDeveloperSummaryView";
import {ProjectContext} from "../../contexts/ProjectContext";
import {useToast} from "../../hooks/use-toast";
import {Button} from "../ui/button";
import {DataTable} from "../ui/dataTable";
import {CompareBidsInline} from "../developer/compareBids";


export const _columns: ColumnDef<BidBaseModel>[] = [

    {
        header: ({column}) => <SortableHeader column={column} name={"Amount"}/>,
        accessorKey: "bid_amount",
        cell: ({row}) => {
            const amount = row.original.bid_amount;
            const formatted = moneyFormatter.format(amount);
            return <div className="text-center font-medium ">{formatted}</div>;
        },
    },
    {
        header: "Title",
        accessorKey: "title",

    },
    {
        header: ({column}) => <SortableHeader column={column} name={"Created on"}/>,
        accessorKey: "created_at",
        cell: ({row}) => {
            const date = new Date(row.original.created_at);
            return <span>{date.toLocaleDateString()}</span>;
        },
    },
    {
        header: ({column}) => <SortableHeader column={column} name={"Status "}/>,
        accessorKey: "status",
    },
    {

        header: ({column}) => <SortableHeader column={column} name={"Response"}/>,
        accessorKey: "response_status",
    },
    {
        header: ({column}) => <SortableHeader column={column} name={"Submitted on"}/>,
        accessorKey: "submitted_at",
        cell: ({row}) => {
            if (row.original.submitted_at) {
                const date = new Date(row.original.submitted_at);
                return <span>{date.toLocaleDateString()}</span>;
            } else {
                return <></>;
            }
        },
    },
];


const scope_columns: ColumnDef<BidBaseModel>[] = [
       {
        header: ({column}) => <SortableHeader column={column} name={"Scope"}/>,
        accessorKey: "scope.title",
    },
];

export const _columnsDeveloper: ColumnDef<BidBaseModel>[] = [

    {
        header: ({column}) => <SortableHeader column={column} name={"Amount"}/>,
        accessorKey: "bid_amount",
        cell: ({row}) => {
            const amount = row.original.bid_amount;
            const formatted = moneyFormatter.format(amount);
            return <div className="text-center font-medium ">{formatted}</div>;
        },
    },
    {

        header: ({column}) => <SortableHeader column={column} name={"Company"}/>,
        accessorKey: "company_name",
    },
    {
        header: ({column}) => <SortableHeader column={column} name={"Response"}/>,
        accessorKey: "response_status",
    },
    {
        header: ({column}) => <SortableHeader column={column} name={"Submitted"}/>,
        accessorKey: "submitted_at",
        cell: ({row}) => {
            if (row.original.submitted_at) {
                const date = new Date(row.original.submitted_at);
                return <span>{date.toLocaleDateString()}</span>;
            } else {
                return <></>;
            }
        },
    },
];




type BidSummaryViewProps = {
    bids: BidBaseModel[]
}

export type BiddingProps = {
    tableData: any[];
    tableColumns: any[]
    handleRowClick: (string:any) => void
}

export type BiddingDeveloperProps = BiddingProps & {
    selectedRows?: string[]; 
  };

export function BidSummaryView({
    bids
}: BidSummaryViewProps) {
    const navigate = useNavigate();
    const {accessToken} = useAuthInfo();
    const {project_id, scope_id} = useParams<{ project_id: string, scope_id: string  }>();
    const [tableData, setTableData] = useState<BidBaseModel[]>(bids || [])
    const [isDeletedBid, setIsDeletedBid] = useState<boolean>(false)
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const projectContext = React.useContext(ProjectContext);
    // const userContext = React.useContext(UserContext);
    const hasScopes = tableData.filter(x => x.scope_id !== null).length > 0;
    console.log(bids)
    const onSelect = (event: React.MouseEvent<HTMLSpanElement>, rowData: any) => {
        event.preventDefault()
        event.stopPropagation()
        
        setSelectedRows((prev) => {
            const newSelectedRows = [...prev]; 
            const index = newSelectedRows.indexOf(rowData.id);
    
            if (index === -1) {
                newSelectedRows.push(rowData.id);
            } else {
                newSelectedRows.splice(index, 1);
            }
            return newSelectedRows;
        });
    }

    const _ds: ColumnDef<BidBaseModel>[] = [
        {
            header: "Delete",
            cell: ({row}) => {
                if (row.original.status === BidStatus.Draft) {
                    return <button
                    disabled={isDeletedBid}
                        // variant={"outline"}
                        onClick={(e) => {
                            e.stopPropagation()
                            onDeleteBid(row.original)
                        }}>
                        <TrashIcon width={15} height={15}/>
                    </button>

                } else {
                    return <></>
                }
            }
        }
    ]

    const selectCol: ColumnDef<BidBaseModel>[] = [
          {
        header: ({column}) => <SortableHeader column={column} name={"x"}/>,
        accessorKey: "selected",
        cell: ({row}) => {
            // console.log(row);
            const isSelected = selectedRows.includes((row.original as any).id);
            return <span
            className={`text-sm ${isSelected || false ? 'text-green-700 font-bold' : 'text-gray-600'} hover:font-bold`} 
            onClick={(event)=> onSelect(event, row.original)}>{isSelected ? 'selected' : 'select'}</span>;
        },
    },

    ]

    const onDeleteBid = (bid: BidBaseModel) => {
        setIsDeletedBid(true)
        deleteWithToken(`/projects/${project_id}/bidding/${bid.id}/delete`,
            accessToken as string)
            .then((res) => {
                // console.log(bid)
                setTableData((prevData) => prevData.filter((item) => item.id !== bid.id));
            }).catch((err) => {

        }).finally(() => {
            setIsDeletedBid(false); 
        });
    }

    const handleRowCLick = (row: any) => {
        let row_id =  row.original._id ? row.original._id : row.original.id;
        row.original.project_id && row_id
            ? navigate(`/project/${row.original.project_id}/bid/${row_id}`)
            : navigate("");
    }
    
    const filterStatus = (selectedSorting: string[], data: any[]) => {
        return data.filter((item) =>
            selectedSorting.includes(item.status) 
        );
    };
    const filterResponseStatus = (selectedSorting: string[], data: any[]) => {
        const updatedSorting = selectedSorting.map(value =>
            value === "blank" ? null : value
        );
        return data.filter((item) =>
            updatedSorting.includes(item.response_status)
        );

    };
    
    
    const tableFilters: Filter[] = [
        {responseStatus: {
              blank: filterResponseStatus,
              rejected: filterResponseStatus,
              in_review: filterResponseStatus,
              validated: filterResponseStatus,
            },
        ...(projectContext?.role === CompanyType.builder && {
            status: {
                submitted: filterStatus,
                draft: filterStatus,
                accepted: filterStatus
            },
          })

    }
    ]

    return (
        <>

            <div>
                <TableFilters
                    availableFilters={tableFilters}
                    data={bids}
                    setData={setTableData}/>
            </div>
                {projectContext?.role === CompanyType.developer ? (
                    <DeveloperBidSummaryView
                        tableData={tableData}
                        tableColumns={[
                            ...selectCol,
                             ...(hasScopes? scope_columns : []),
                            ..._columnsDeveloper]}
                        selectedRows={selectedRows}
                        handleRowClick={handleRowCLick}/>
                ) : (
                    <BiddingBuilderSummaryView
                        tableData={tableData}
                        tableColumns={[
                            ...(hasScopes? scope_columns : []),
                            ..._columns,
                            ..._ds]}
                        handleRowClick={handleRowCLick}/>
                )}

        </>
    );
}

type BidTableDeveloperScopedProps = {
    // the scope page hides its other cards while comparing
    onViewModeChange?: (mode: 'table' | 'compare') => void;
    // a plug was converted to an SOV line in compare
    onSovChanged?: () => void;
}

export function BidTableDeveloperScoped({onViewModeChange, onSovChanged}: BidTableDeveloperScopedProps = {}) {
    const {accessToken} = useAuthInfo()
    const navigate = useNavigate();
    const [bids, setBids] = useState<BidBaseModel[] >([])
    const {project_id, scope_id} = useParams<{ project_id: string, scope_id: string }>();
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const {toast} = useToast()
    const hasScopes = bids.filter(x => x.scope_id !== null).length > 0;
    const [viewMode, setViewMode] = useState<'table' | 'compare'>('table');
    useEffect(() => {
        let url;
        if(scope_id){
            url = `/projects/${project_id}/bidding/?scope_id=${scope_id}`
        } else {
            url = `/projects/${project_id}/bidding/`
        }
        fetchWithToken(url, accessToken as string)
            .then((data) => {
                // console.log(data);
                setBids(data)
            })
            .catch((err) => {
                toast({
                        title: "Error",
                        description: "Failed to load bids: " + JSON.stringify(err),
                        variant: "destructive",
                    })
            })
    }, [project_id])

    const handleRowCLick = (row: any) => {
        let row_id =  row.original._id ? row.original._id : row.original.id;
        row.original.project_id && row_id
            ? navigate(`/project/${row.original.project_id}/bid/${row_id}`)
            : navigate("");
    }

    const filterResponseStatus = (selectedSorting: string[], data: any[]) => {
        const updatedSorting = selectedSorting.map(value =>
            value === "blank" ? null : value
        );
        return data.filter((item) =>
            updatedSorting.includes(item.response_status)
        );
    };

    const onSelect = (event: React.MouseEvent<HTMLSpanElement>, rowData: BidBaseModel) => {
        event.preventDefault()
        event.stopPropagation()

        setSelectedRows((prev) => {
            const newSelectedRows = [...prev];
            const index = newSelectedRows.indexOf(rowData.id);

            if (index === -1) {
                newSelectedRows.push(rowData.id);
            } else {
                newSelectedRows.splice(index, 1);
            }
            return newSelectedRows;
        });
    }

    const selectCol: ColumnDef<BidBaseModel>[] = [
          {
            header: ({column}) => <SortableHeader column={column} name={"x"}/>,
            accessorKey: "selected",
            cell: ({row}) => {
                // console.log(row);
                const isSelected = selectedRows.includes((row.original as any).id);
                return <span
                className={`text-sm ${isSelected || false ? 'text-green-700 font-bold' : 'text-gray-600'} hover:font-bold`}
                onClick={(event)=> onSelect(event, row.original)}>
                    {isSelected ? 'selected' : 'select'}</span>;
            },
        },

    ]

    const tableFilters: Filter[] = [
        {responseStatus: {
              blank: filterResponseStatus,
              rejected: filterResponseStatus,
              in_review: filterResponseStatus,
              validated: filterResponseStatus,
            },
        }
    ]

    const onToggleView = () => {
        const next = viewMode === 'table' ? 'compare' : 'table';
        setViewMode(next);
        onViewModeChange && onViewModeChange(next);
    }

    if (!bids) {
        return <></>;
    }
    // return <BidSummaryView bids={bids}/>
    return (
        <div className="relative">
            <div>
                <div className="absolute -top-[55px] right-0">
                    {/*<Button variant="outline" type="button" onClick={onViewChart} className="mr-3">*/}
                    {/*    View chart*/}
                    {/*</Button>*/}
                    <Button variant="outline" type="button" onClick={onToggleView}>
                        {viewMode === 'table' ? 'Compare' : 'Back to Table'}
                    </Button>
                </div>
            </div>
            <div>
                {viewMode === 'table' ? (
                    <DataTable
                        data={bids}
                        columns={[
                                ...selectCol,
                                 ...(hasScopes? scope_columns : []),
                                ..._columnsDeveloper]}
                        handleRowClick={handleRowCLick}
                    />
                ) : (
                    <CompareBidsInline
                        selectedRows={selectedRows}
                        bids={bids}
                        onSovChanged={onSovChanged}/>
                )}
            </div>
        </div>
    );
}


function BidSummary() {
    const {accessToken} = useAuthInfo()
    const [bids, setBids] = useState<BidBaseModel[] | null>(null)
    const {project_id, scope_id} = useParams<{ project_id: string, scope_id: string }>();
    const {toast} = useToast()

    useEffect(() => {
        let url;
        if(scope_id){
            url = `/projects/${project_id}/bidding/?scope_id=${scope_id}`
        } else {
            url = `/projects/${project_id}/bidding/`
        }
        fetchWithToken(url, accessToken as string)
            .then((data) => {
                // console.log(data);
                setBids(data)
            })
            .catch((err) => {
                toast({
                        title: "Error",
                        description: "Failed to load bids: " + JSON.stringify(err),
                        variant: "destructive",
                    })
            })
    }, [project_id])

    if (!bids) {
        return <></>;
    }
    return <Card>
            <CardHeader>
                <CardTitle>
                    <div className="flex columns-2 justify-between">
                        <div>Bids</div>
                        <div className="justify-end"></div>
                    </div>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <BidSummaryView bids={bids}/>
            </CardContent>
    </Card>
}


export default BidSummary;
